var _path, _path2, _path3, _path4, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5743 45.9989C22.5743 45.9989 30.9261 46.2338 38.1711 39.9459C46.1429 33.0259 44.9346 18.2976 44.9346 18.2976C44.9346 18.2976 43.4101 21.2841 36.5734 25.1119C33.1397 27.0363 29.3497 28.0491 26.6476 31.7288C23.5089 36.003 22.5743 45.9989 22.5743 45.9989Z",
    fill: "url(#linear_first)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4233 45.9989C22.4233 45.9989 14.0739 46.2338 6.82893 39.9459C-1.1429 33.0259 0.0653834 18.2976 0.0653834 18.2976C0.0653834 18.2976 1.58989 21.2841 8.42659 25.1119C11.8603 27.0363 15.648 28.0491 18.3524 31.7288C21.4911 36.003 22.4233 45.9989 22.4233 45.9989Z",
    fill: "url(#linear_second)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6574 11.8943C17.6613 11.1559 18.4366 10.6762 19.0991 11.0023L31.6479 17.18C32.4055 17.553 32.3883 18.6391 31.6193 18.9879L19.0089 24.707C18.3448 25.0082 17.5921 24.5203 17.5959 23.7912L17.6574 11.8943Z",
    fill: "url(#linear_third)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3163 16.4742C42.5708 12.1003 39.5741 8.33294 35.6979 5.63942C35.2259 5.31045 34.7358 4.99715 34.2276 4.69952C33.7195 4.40188 33.2097 4.12696 32.6984 3.87475C31.6601 3.36501 30.583 2.9376 29.4771 2.59648C27.271 1.89764 24.9696 1.54255 22.6546 1.54379C17.99 1.54157 13.4336 2.94297 9.58296 5.56423C5.66831 8.21006 2.60302 11.9238 0.754481 16.2603L0.532648 16.1804C1.89432 11.5726 4.91031 7.43698 8.84902 4.54443C10.8335 3.08662 13.0364 1.94947 15.3766 1.17488C17.7256 0.398783 20.1843 0.00213739 22.6593 0C25.1331 0.0118919 27.5894 0.413172 29.9373 1.18898C33.4514 2.37045 36.6262 4.3811 39.1906 7.04927C40.0315 7.92816 40.8023 8.87092 41.4962 9.86898C42.8721 11.8625 43.9012 14.0724 44.5405 16.406L44.3163 16.4742Z",
    fill: "url(#linear_fourth)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_first",
    x1: 45,
    y1: -7.5,
    x2: 6.5,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#605DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_second",
    x1: 45,
    y1: -7.5,
    x2: 6.5,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#605DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_third",
    x1: 45,
    y1: -7.5,
    x2: 6.5,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#605DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_fourth",
    x1: 45,
    y1: -7.5,
    x2: 6.5,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#605DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A3EE"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.3d9e7a07.svg";
export { ForwardRef as ReactComponent };